import React from 'react';
import { AdminInput, AdminTextarea, AdminToggle, AdminSectionCard } from './AdminFormInput';
import type { CompanyData } from '@/hooks/useCompanyData';

interface CompanyFormProps {
  data: CompanyData;
  onChange: (data: CompanyData) => void;
}

export default function CompanyForm({ data, onChange }: CompanyFormProps) {
  const update = (key: keyof CompanyData, value: unknown) => {
    onChange({ ...data, [key]: value } as CompanyData);
  };

  return (
    <div className="space-y-5">
      <AdminSectionCard title="Dados da Empresa" icon="ri-building-line">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminInput
            label="Nome da Empresa"
            value={data.name}
            onChange={(e) => update('name', e.target.value)}
          />
          <AdminInput
            label="Slogan / Tagline"
            value={data.name}
            onChange={(e) => update('name', e.target.value)}
          />
          <AdminInput
            label="Ano de Fundação"
            type="number"
            value={data.foundedYear}
            onChange={(e) => update('foundedYear', parseInt(e.target.value, 10))}
          />
          <AdminInput
            label="CNPJ"
            value={data.cnpj}
            onChange={(e) => update('cnpj', e.target.value)}
          />
          <AdminInput
            label="Telefone 1"
            value={data.phone1}
            onChange={(e) => update('phone1', e.target.value)}
          />
          <AdminInput
            label="Telefone 2"
            value={data.phone2}
            onChange={(e) => update('phone2', e.target.value)}
          />
          <AdminInput
            label="WhatsApp"
            value={data.phone1}
            onChange={(e) => update('phone1', e.target.value)}
          />
          <AdminInput
            label="E-mail"
            type="email"
            value={data.email}
            onChange={(e) => update('email', e.target.value)}
          />
          <AdminInput
            label="Site"
            value={data.website}
            onChange={(e) => update('website', e.target.value)}
          />
          <AdminInput
            label="Cidade"
            value={data.city}
            onChange={(e) => update('city', e.target.value)}
          />
          <AdminInput
            label="Estado"
            value={data.state}
            onChange={(e) => update('state', e.target.value)}
          />
          <AdminInput
            label="Responsável"
            value={data.responsible}
            onChange={(e) => update('responsible', e.target.value)}
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <AdminInput
            label="Horário Semana"
            value={data.workHours.weekday}
            onChange={(e) => update('workHours', { ...data.workHours, weekday: e.target.value })}
          />
          <AdminInput
            label="Horário Sábado"
            value={data.workHours.saturday}
            onChange={(e) => update('workHours', { ...data.workHours, saturday: e.target.value })}
          />
        </div>
      </AdminSectionCard>
    </div>
  );
}